export default {
	common: {
		disabled: 'Deaktiviert',
		enabled: 'Aktiviert',
		saving: 'Speichere…',
		error: 'Fehler',
		time: {
			time: 'Zeit',
			past: 'Vergangen',
			present: 'Aktuell',
			future: 'Zukünftig',
		},
		severity: {
			debug: 'Debuggen',
			info: 'Information',
			warning: 'Warnung',
			critical: 'Kritisch',
			emergency: 'Notfall',
		},
	},
	sidebar: {
		dashboard: 'Übersicht',
		bands: 'Bands',
		stages: 'Bühnen',
		timeslots: 'Zeitplan',
		shifts: 'Schichten',
		screens: 'Bildschirme',
		stage_manager_shifts: 'Stage Manager Schichten',
		stage_notifications: 'Benachrichtigungen',
		admin_header: 'Administration',
		stage_plan_items: 'Riser & Bilder',
	},
	pages: {
		dashboard: {
			title: 'Übersicht',
			add: 'Neue Aufgabe hinzufügen',
			current_tasks: 'Heutige Aufgaben',
			no_entries: 'Keine Einträge',
			no_stages: 'Keine Bühnen gefunden',
		},
		bands: {
			title: 'Bands',
			add: 'Neue Band hinzufügen',

			deleted: 'Band "{name}" erfolgreich gelöscht.',
			updated: 'Band "{name}" erfolgreich aktualisiert.',
			created: 'Band "{name}" erfolgreich erstellt.',
		},
		timeslots: {
			title: 'Zeitplan',
			add: 'Neuen Eintrag hinzufügen',

			deleted: 'Timeslot "{name}" erfolgreich gelöscht.',
			updated: 'Timeslot "{name}" erfolgreich aktualisiert.',
			created: 'Timeslot "{name}" erfolgreich erstellt.',
		},
		stages: {
			title: 'Bühnen',
			add: 'Neue Bühne hinzufügen',

			deleted: 'Bühne "{name}" erfolgreich gelöscht.',
			updated: 'Bühne "{name}" erfolgreich aktualisiert.',
			created: 'Bühne "{name}" erfolgreich erstellt.',
			plan: 'Bühnenplan',
			edit: 'Bühne bearbeiten',
		},
		stage_notifications: {
			title: 'Bühnen Benachrichtigungen',
			add: 'Neue Bühnen Benachrichtigung hinzufügen',

			deleted: 'Benachrichtigung "{name}" erfolgreich gelöscht.',
			updated: 'Benachrichtigung "{name}" erfolgreich aktualisiert.',
			created: 'Benachrichtigung "{name}" erfolgreich erstellt.',
		},
		shifts: {
			title: 'Schichten',
			add: 'Neue Schicht hinzufügen',

			deleted: 'Schicht "{name}" erfolgreich gelöscht.',
			updated: 'Schicht "{name}" erfolgreich aktualisiert.',
			created: 'Schicht "{name}" erfolgreich erstellt.',
		},
		stage_manager_shifts: {
			title: 'Stage Manager Schichten',
			add: 'Neue Stage Manager Schicht hinzufügen',

			deleted: 'Stage Manager Schicht "{name}" erfolgreich gelöscht.',
			updated: 'Stage Manager Schicht "{name}" erfolgreich aktualisiert.',
			created: 'Stage Manager Schicht "{name}" erfolgreich erstellt.',
		},
		screens: {
			title: 'Informations Bildschirme',
			add: 'Neuen Bildschirm hinzufügen',

			deleted: 'Bildschirm "{name}" erfolgreich gelöscht.',
			updated: 'Bildschirm "{name}" erfolgreich aktualisiert.',
			created: 'Bildschirm "{name}" erfolgreich erstellt.',

			copy_screen_link: 'Bildschirm Link kopieren',
			copy_screen_link_success: 'Link für Bildschirm "{name}" wurde kopiert.',
			copy_screen_link_failure: 'Bildschirm Link kopieren fehlgeschlagen.',
		},
		settings: {
			logos: {
				title: 'Logos',
				logo1: 'Logo 1',
				logo2: 'Logo 2',
				saved: 'Logos erfolgreich gespeichert.',
			},
			idle_texts: {
				title: 'Bildschirm-Texte (Leerlauf)',
				hint: 'Wird auf dem Bühnen-Bildschirm angezeigt, wenn kein Slot läuft. Ein Tag beginnt um 06:00 Uhr.',
				before_event: 'Vor Beginn der Veranstaltung',
				before_first_slot: 'Vor dem ersten Slot des Tages',
				after_event: 'Nach dem letzten Slot der Veranstaltung',
				saved: 'Texte erfolgreich gespeichert.',
			},
		},
		integrations: {
			producely: {
				title: 'Producely',
				path: 'API Pfad',
				token: 'API Token',
				save: 'Einstellungen speichern',
				saved: 'Einstellungen erfolgreich gespeichert.',
				import: 'Import starten',
				importing: 'Importiere…',
				result: 'Import-Ergebnis',
				created: 'Erstellt',
				updated: 'Aktualisiert',
				bands: 'Bands',
				timeslots: 'Zeitplan',
			},
		},
		stage_plan: {
			no_plan:
				'Für diese Bühne ist noch keine Draufsicht hinterlegt. Riser und Bilder lassen sich trotzdem schon platzieren.',
			upload_plan: 'Draufsicht hochladen',
			back: 'Zurück zu den Bühnen',
			add_rect: 'Riser',
			add_image: 'Bild',
			edit_stage: 'Bühne und Draufsicht bearbeiten',
			kind: {
				rect: 'Riser',
				image: 'Bild',
			},
			context: {
				edit: 'Bearbeiten',
				rotate: '90° drehen',
				duplicate: 'Duplizieren',
				delete: 'Löschen',
				add_rect: 'Riser hier einfügen',
				add_image: 'Bild hier einfügen',
			},
			conflict_title: 'Nicht gespeichert',
			conflict:
				'"{name}" wurde inzwischen von jemand anderem geändert. Der Plan zeigt jetzt den aktuellen Stand.',
		},
		stage_plan_items: {
			title: 'Riser & Bilder der Bühnenpläne',
		},
		band: {
			not_found: 'Diese Band gibt es in diesem Event nicht (mehr).',
			no_stage: 'Noch keiner Bühne zugeordnet',
			confirm_delete:
				'Willst du die Band "{name}" mit ihren Zeitslots, Dokumenten und Anforderungen wirklich löschen? Das kann nicht rückgängig gemacht werden.',
			unsaved_title: 'Ungespeicherte Änderungen',
			unsaved_text:
				'Auf dieser Seite sind Änderungen noch nicht gespeichert. Willst du sie verwerfen und die Seite verlassen?',
			general: {
				contacts: 'Ansprechpartner',
				no_contacts: 'Noch keine Ansprechpartner.',
			},
			timeslots: {
				no_stage:
					'Die Band ist noch keiner Bühne zugeordnet. Ihre Zeitslots erscheinen erst im Zeitplan einer Bühne, wenn du sie im Tab Allgemein einer Bühne zuordnest.',
			},
			documents: {
				upload_as: 'Neue Dateien ablegen unter',
				hint: 'PDF, Bilder, Office-Dokumente, Text oder Zeichnungen (DWG, DXF), bis 30 MB je Datei',
				empty: 'Noch keine Dokumente. Rider, Bühnenanweisungen und technische Zeichnungen kommen hierher.',
				confirm_delete:
					'Willst du das Dokument "{name}" wirklich löschen? Das kann nicht rückgängig gemacht werden.',
			},
			requirements: {
				hint: 'Was die Band auf der Bühne braucht. Maße in Metern.',
				empty: 'Noch keine Anforderungen.',
			},
		},
	},
	modals: {
		edit_band: {
			create: 'Band erstellen',
		},
		edit_timeslot: {
			edit: 'Existierenden Timeslot editieren',
			create: 'Neuen Timeslot erstellen',

			confirm_delete:
				'Bist du dir sicher dass du den Timeslot "{name}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!',
		},
		edit_stage: {
			edit: 'Existierende Bühne editieren',
			create: 'Neue Bühne erstellen',

			confirm_delete:
				'Bist du dir sicher dass du die Bühne "{name}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!',
			plan_source: {
				pdf: 'Draufsicht (PDF)',
				image: 'Draufsicht (Bild)',
			},
			plan_remove: 'Draufsicht entfernen',
			plan_hint: 'PDF mit Maßstab oder Bild (PNG, JPEG, WebP). Bei einem PDF zählt die erste Seite.',
			plan_scale_pdf: 'Maßstab',
			plan_scale_image: 'Pixel pro Meter',
			plan_size: 'ergibt {width} × {height} m',
		},
		edit_stage_notification: {
			edit: 'Vorhandene Benachrichtigung bearbeiten',
			create: 'Neue Benachrichtigung erstellen',

			confirm_delete:
				'Bist du dir sicher dass du die Benachrichtigung "{name}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!',
		},
		edit_shift: {
			edit: 'Vorhandene Schicht bearbeiten',
			create: 'Neue Schicht erstellen',

			confirm_delete:
				'Bist du dir sicher dass du die Schicht "{name}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!',
		},
		edit_stage_manager_shift: {
			edit: 'Vorhandene Stage Manager Schicht editieren',
			create: 'Neue Stage Manager Schicht erstellen',

			confirm_delete:
				'Bist du dir sicher dass du die Stage Manager Schicht von "{name}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!',
		},
		edit_screen: {
			edit: 'Vorhandenen Bildschirm editieren',
			create: 'Neuen Bildschirm erstellen',

			confirm_delete:
				'Bist du dir sicher dass du den Bildschirm "{name}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!',
		},
		edit_event: {
			create_demo_data: 'Mit Demo-Daten befüllen',
			create_demo_data_hint:
				'Befüllt das Event mit typischen Bühnen, Bands und Schichten, damit du die App sofort ausprobieren kannst.',
		},
		edit_timeslot_type: {
			create: 'Neuen Timeslot Typ erstellen',
			edit: 'Timeslot Typ bearbeiten',
		},
		import_event_data: {
			title: 'Daten importieren',
			file: 'Datei (CSV / TSV)',
			type: 'Typ',
			type_artists: 'Künstler',
			type_local_crew: 'Local Crew',
			type_stage_manager_shifts: 'Stage Manager Schichten',
			preview: 'Vorschau',
			confirm_import: 'Import bestätigen',
			columns_artists:
				'Erwartete Spalten: Stage Name · Artist · Stagetime Start · Stagetime End · Load-In Start · Load-In End · Soundcheck Start · Soundcheck End',
			columns_local_crew:
				'Erwartete Spalten: Stage Name · Shift Name (e.g. early/late) · Crew Size · Shift Start · Shift End · Crew Type',
			columns_stage_manager_shifts:
				'Erwartete Spalten: Stage Name · Stage Manager Name · Contact Info · Shift Start · Shift End',
		},
		edit_stage_plan_item: {
			create_rect: 'Riser platzieren',
			create_image: 'Bild platzieren',
			edit_rect: 'Riser bearbeiten',
			edit_image: 'Bild bearbeiten',
			file_hint: 'SVG, PNG, JPEG oder WebP, höchstens 4 MB. Das Seitenverhältnis wird übernommen.',
			keep_ratio: 'Seitenverhältnis beibehalten',
			confirm_delete: 'Soll "{name}" wirklich vom Bühnenplan entfernt werden?',
		},
	},
	confirms: {
		delete_timeslot_type: {
			title: 'Timeslot Typ löschen',
			text: 'Bist du dir sicher dass du den Timeslot Typ "{item}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!',
		},
	},
	buttons: {
		band: {
			open: 'Band öffnen',
			back: 'Zurück zu den Bands',
			delete: 'Band löschen',
			delete_image: 'Bild löschen',
		},
		timeslot: {
			add: 'Zeitslot hinzufügen',
			remove: 'Zeitslot entfernen',
		},
		band_contact: {
			add: 'Ansprechpartner hinzufügen',
			remove: 'Ansprechpartner entfernen',
		},
		band_document: {
			rename: 'Umbenennen',
			delete: 'Dokument löschen',
		},
		band_requirement: {
			add_riser: 'Riser',
			remove: 'Anforderung entfernen',
		},
	},

	data: {
		band: {
			name: 'Bandname',
			stage_name: 'Bühnenname',
			stage: 'Bühne',
			description: 'Beschreibung',
			notes: 'Notizen für die Crew',
		},
		stage: {
			name: 'Bühnenname',
			primary_color: 'Primär Farbe',
			secondary_color: 'Sekundär Farbe',
			icon_uri: 'Logo',
			start_at: 'Öffnungszeit',
			end_at: 'Schließzeit',
			event_id: 'Event ID',
			row_color_indicator: '',
			plan: 'Draufsicht',
			plan_scale: 'Maßstab',
		},
		stageNotification: {
			name: 'Bühnen Benachrichtigung',
			title: 'Titel',
			message: 'Nachricht',
			icon_uri: 'Logo',
			icon: 'Icon',
			stage: 'Bühne',
			severity: 'Dringlichkeit',
			show_at: 'Zeigen ab',
			hide_at: 'Verstecken ab',
			stage_name: 'Bühne',
			severity_icon: '',
		},
		shift: {
			name: 'Schichtname',
			head_count: 'Personalstärke',
			start_at: 'Startzeitpunkt',
			end_at: 'Endzeitpunkt',
			stage_name: 'Bühne',
		},
		stageManagerShift: {
			name: 'Stage Manager Schicht',
			user_avatar: '',
			user_name: 'Bühnen Manager',
			contact_info: 'Kontakt Info',
			start_at: 'Startzeitpunkt',
			end_at: 'Endzeitpunkt',
			stage_name: 'Bühne',
		},
		timeslot_type: {
			id: 'Id',
			name: 'Name',
			color: 'Farbe',
			preview: 'Vorschau',
			timeslots_count: '# Timeslots',
			description: 'Beschreibung',
		},
		timeslot: {
			name: 'Timeslot/Band',
			comment: 'Kommentar',
			type: 'Typ',
			start_at: 'Startzeitpunkt',
			end_at: 'Endzeitpunkt',
			show_in_timer: 'Im Timer anzeigen',
			stage_name: 'Bühne',
		},
		screen: {
			name: 'Bildschirmname',
			last_heartbeat_at: 'Last Heartbeat At',
			last_ip: 'Letzte IP',
			enabled: 'Status',
			stage_name: 'Bühne',
			event: {
				name: 'Event',
			},
			stage: {
				name: 'Bühne',
			},
		},
		stage_plan_item: {
			name: 'Bezeichnung',
			file: 'Bild',
			width: 'Breite',
			height: 'Tiefe',
			rotation: 'Drehung',
			color: 'Farbe',
			kind: '',
			stage_name: 'Bühne',
			position: 'Position X / Y',
		},
		band_contact: {
			firstname: 'Vorname',
			lastname: 'Nachname',
			email: 'E-Mail',
			phone: 'Telefon',
		},
		band_document: {
			category: 'Kategorie',
		},
		band_requirement: {
			type: 'Art',
			quantity: 'Anzahl',
			width: 'Breite',
			depth: 'Tiefe',
			height: 'Höhe',
			note: 'Notiz',
		},
	},

	tabs: {
		context_settings: {
			general: 'Allgemein',
			timeslot_types: 'Timeslot Typen',
			integrations: 'Integrationen',
		},
		admin_settings: {
			design: 'Mail-Design',
		},
		band: {
			general: 'Allgemein',
			timeslots: 'Zeitslots',
			documents: 'Dokumente',
			requirements: 'Anforderungen',
		},
	},

	filters: {
		timeslot_type: 'Zeitslot Typ',
	},
	components: {
		occupied_days: {
			note: 'Vom {first} bis {last} liegen schon Bühnen, Zeitslots oder Schichten. Der Zeitraum muss diese Tage einschließen.',
		},
		svg_map: {
			zoom_in: 'Vergrößern',
			zoom_out: 'Verkleinern',
			fit: 'Alles anzeigen',
			entities_smaller: 'Beschriftung verkleinern',
			entities_bigger: 'Beschriftung vergrößern',
			layers: 'Darstellung',
			color: 'Farbig',
			grayscale: 'Grau',
			coordinates: 'Koordinaten',
			grid: 'Meterraster',
			center: 'Hier zentrieren',
			copy_coordinates: 'Koordinaten kopieren',
			cursor_outside: 'Zeiger über den Plan bewegen',
		},
		band_timeslots: {
			title: 'Zeitslots',
			empty: 'Noch keine Zeitslots.',
			timeslot_type: 'Typ',
			start: 'Start',
			end: 'Ende',
			show_in_timer: 'Im Timer anzeigen',
		},
		band_image: {
			title: 'Bild oder Logo',
			none: 'Kein Bild.',
			drop: 'Bild hier ablegen',
			replace: 'Anderes Bild ablegen',
			hint: 'PNG, JPG, WebP oder GIF bis 4 MB, wird sofort gespeichert',
			confirm_delete: 'Willst du das Bild der Band wirklich löschen?',
		},
	},
	enums: {
		band_document_category: {
			rider: 'Rider / Bühnenanweisung',
			technical_drawing: 'Technische Zeichnungen',
			other: 'Sonstiges',
		},
		band_requirement_type: {
			riser: 'Riser',
		},
	},
};
